export function transformToNumber(val: any) {
    if (Number.isNaN(val) || val === '') {
        return null;
    }
    return val;
}
